import * as S from "./CommentFloatMessage.style";
import ImgGuardian from "@/styles/assets/images/img_parent.png";
import { useNavigate } from "react-router";
import { ReactComponent as IconArrow } from "@/styles/assets/svg/icon_float_arrow.svg";

export const CommentFloatMessage = () => {
  const navigate = useNavigate();

  return (
    <S.CommentFloatMessage onClick={() => navigate("/comment/history")}>
      <S.MessageInfoBox>
        <S.GuardianImg>
          <img src={ImgGuardian} alt="보호자 이미지" />
        </S.GuardianImg>
        <S.MessageTit>
          <span>응원 메시지</span>
          <div>법정보호자가 전송한 피드백 메시지를 보여줍니다.</div>
        </S.MessageTit>
      </S.MessageInfoBox>

      <IconArrow />
    </S.CommentFloatMessage>
  );
};
